"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProcess = void 0;
const snap_ui_1 = require("@teamsnap/snap-ui");
const api_1 = require("core/api");
const React = __importStar(require("react"));
const react_router_1 = require("react-router");
const useNavigation_1 = require("src/hooks/useNavigation");
const useProcess = () => {
    const { navigate } = (0, useNavigation_1.useNavigation)();
    const { toast } = (0, snap_ui_1.useToast)();
    const location = (0, react_router_1.useLocation)();
    const urlParams = new URLSearchParams(location.search);
    const checkoutContext = urlParams?.get('checkoutContext');
    const invitationCode = urlParams?.get('invitationCode');
    React.useEffect(() => {
        if (checkoutContext === api_1.UserSubscriptionCheckoutContextType_Invitation.INVITATION && invitationCode) {
            toast({
                variant: 'success',
                title: 'Success!',
            });
            setTimeout(() => {
                navigate.continueInviteClassic(invitationCode);
            }, 1500);
        }
        if (checkoutContext === api_1.UserSubscriptionCheckoutContextType_SubscriptionManage.SUBSCRIPTION_MANAGE) {
            navigate.classicTeamBilling();
        }
    }, [checkoutContext, invitationCode]);
    return {
        isProcessing: true,
    };
};
exports.useProcess = useProcess;
